import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=b8b3ddc8"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"
import style0 from "./Blank.vue?vue&type=style&index=0&id=b8b3ddc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports